import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';
import type { Control } from 'react-hook-form';

interface SelectInputProps {
    field: {
        handle: string;
        label?: string;
        instructions?: string;
        options?: Array<{
            label?: string;
            value?: string;
        }>;
    };
    control: Control<Record<string, unknown>>;
}

export default function SelectInput({ field, control }: SelectInputProps) {
    return (
        <FormField
            control={control}
            name={field.handle}
            render={({ field: formField }) => (
                <FormItem>
                    <FormLabel>{field.label}</FormLabel>
                    <FormControl>
                        <Select
                            value={formField.value as string}
                            onValueChange={formField.onChange}
                        >
                            <SelectTrigger className="bg-white">
                                <SelectValue placeholder="Select an option" />
                            </SelectTrigger>
                            <SelectContent className="bg-white font-neue-haas">
                                {field.options?.map((option) => (
                                    <SelectItem key={option.value} value={option.value || ''}>
                                        {option.label}
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </FormControl>
                    {field.instructions && (
                        <p className="text-muted-foreground text-sm">{field.instructions}</p>
                    )}
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
